@use '../../scss/utility';
@use 'subnavigation-fly-in-vars';

:host {
  @include subnavigation-fly-in-vars.wb-subnavigation-fly-in-vars;
  display: block;
  position: sticky;
  inset-inline: 0;
  inset-block-start: 0;
  width: 100%;
  z-index: var(--z-index);
}

/* TODO: refactor component to allow for easier styling of the buttons  */
::slotted([slot='header-button']) {
  margin-inline-start: var(--wb-spacing-xxs);
}

::slotted(.wb-subnavigation-fly-in-item:last-of-type) {
  margin-block-end: var(--subnavigation-fly-in-gap);
}

::slotted(.wb-button) {
  width: 100%;
}

::slotted(.wb-button:first-of-type) {
  margin-block-start: auto !important;
}

::slotted(.wb-button:nth-of-type(2)) {
  margin-block-start: var(--subnavigation-fly-in-bottom-actions-gap) !important;
}

.inner {
  width: var(--wb-grid-width);
  max-height: calc(100% - 60px);
  height: 100%;
  overflow: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: var(--subnavigation-fly-in-gap) 0 var(--subnavigation-fly-in-padding-bottom);
  box-sizing: border-box;
}

.wb-fly-in {
  @include subnavigation-fly-in-vars.wb-subnavigation-fly-in-open-vars;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  appearance: none;
  color: var(--subnavigation-fly-in-text-color);
  background-color: var(--subnavigation-fly-in-background-color);
  width: 100%;
  outline: 0;
  padding: var(--subnavigation-fly-in-header-padding);
  text-align: start;
  cursor: pointer;
  user-select: none;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}

.has-shadow {
  box-shadow: var(--wb-shadow-m);
  border-block-end: var(--subnavigation-fly-in-border-weight) solid var(--subnavigation-fly-in-border-color);
}

.header-inner {
  display: flex;
  width: var(--wb-grid-width);
  margin: 0 auto;
}

.start,
.end {
  display: flex;
  justify-content: center;
}

.start {
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
}

.start .wb-text {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.end {
  align-items: center;
}
